import { render, staticRenderFns } from "./EditProxyForm.vue?vue&type=template&id=710d5313&"
import script from "./EditProxyForm.vue?vue&type=script&lang=js&"
export * from "./EditProxyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports